const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

const patchData = async ({ data, uri }: any) => {
  const response = await fetch(`${REACT_APP_API_URL}/${uri}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  if (response.status !== 200) {
    return Promise.reject("Something went wrong");
  }
  return response.json();
};

export default patchData;
